import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import socialUtils from "global/social/utils"
import { connect } from "lib/core/store"
import PropTypes from "prop-types"
import "./ShareIcons.css"

const ICON_COLORS_MAP = {
  envelope: "orange",
  twitter: "#4099FF",
  facebook: "#3B5998",
  "googleplus-o": "#DD4B39",
  pinterest: "#C92228"
}

const ShareIcons = ({ shareLinks, inverted }) =>
  shareLinks ? (
    <div className="ShareIcons">
      {shareLinks.map(({ icon, share_url }) => {
        const color = inverted ? "white" : ICON_COLORS_MAP[icon]

        return (
          <a key={icon} target="_blank" href={share_url}>
            <Pathicon icon={icon} style={{ color }} />
          </a>
        )
      })}
    </div>
  ) : null

ShareIcons.displayName = "ShareIcons"
ShareIcons.propTypes = {
  inverted: PropTypes.bool,
  // title for share message
  title: PropTypes.string.isRequired,
  // bool or object with body text
  mail: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
}
ShareIcons.defaultProps = {
  mail: true, // but this doesn't get passed to mapStateToProps in ownProps
  inverted: false
}

const mapStateToProps = function (state, ownProps) {
  const { title, mail } = ownProps
  const { resource } = state.resourceStore.state

  const shareLinks = socialUtils.getShareLinksForResource(resource, title)

  // If mail then add mail icon
  if (mail) {
    const body = mail.body ? `&body=${mail.body}` : ""
    shareLinks.push({
      share_url: `mailto:?subject=${title}${body}`,
      icon: "envelope"
    })
  }

  const props = _.assign(
    {
      shareLinks
    },
    ownProps
  )

  return props
}

export default connect(ShareIcons, "resource", mapStateToProps, false)
